<template>
  <div class="container">
    <button class="button is-primary is-small is-pulled-right" @click="add">
      <span class="icon">
        <i class="fas fa-plus"></i>
      </span>
      <span>Cadastrar</span>
    </button>
    <br><br>

    <div class="modal" :class="{ 'is-active': isShowModal }">
      <div class="modal-background" v-on:click="isShowModal = false"></div>
      <div class="modal-card">
        <header class="modal-card-head has-background-primary">
          <p class="modal-card-title has-text-white">Cadastrar</p>
          <button class="delete" aria-label="close" v-on:click="isShowModal = false"></button>
        </header>
        <section class="modal-card-body">
          <form v-if="!mostraOutrasInfoVersaoConfig && !mostraCompartilhamento">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Descrição</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe a descrição" v-model="outraInformacao.descricao">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Nome da Fórmula</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe o nome da fórmula" v-model="outraInformacao.nome_formula">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Comentários</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <textarea class="textarea" placeholder="Comente sobre essa outra informação" v-model="outraInformacao.comentario"></textarea>
                  </p>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraCompartilhamento">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Versão</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="outrasInformacoesCompartilhar.versao_plano_contas">
                        <option v-for="versao_plano_contas in versoesPlanoContas" :key="versao_plano_contas.id" :value="versao_plano_contas">
                          {{ versao_plano_contas.descricao }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <form v-if="mostraOutrasInfoVersaoConfig">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Descrição</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" placeholder="Informe a descrição" v-model="outrasInformacoesVersaoConfig.descricao">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Sequencial</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" v-model="outrasInformacoesVersaoConfig.sequencial">
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Calculado</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="outrasInformacoesVersaoConfig.eCalculado">
                      <option value="S">Sim</option>
                      <option value="N">Não</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Desejada</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="select is-fullwidth">
                    <select v-model="outrasInformacoesVersaoConfig.tipo_evolucao_desejada">
                      <option value="A">Alta</option>
                      <option value="B">Baixa</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Fórmula</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <textarea class="textarea" placeholder="Informe a fórmula para preenchimento" v-model="outrasInformacoesVersaoConfig.formula" :disabled="outrasInformacoesVersaoConfig.eCalculado === 'N'"></textarea>
                  </p>
                </div>
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="save">Salvar</button>
          <button class="button" v-on:click="isShowModal = false">Cancelar</button>
        </footer>
      </div>
    </div>

    <div class="columns">
      <div class="column is-5">
        <div class="card">
          <header class="card-header has-background-primary">
            <p class="card-header-title has-text-white">Outras Informações</p>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Descrição</th>
                    <th>Comentários</th>
                    <th class="has-text-centered">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(oiv, index) in outrasInformacoes" :key="oiv.id">
                    <td>{{ oiv.descricao }}</td>
                    <td>{{ oiv.comentario }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" :disabled="mostraCompartilhamento || mostraOutrasInfoVersaoConfig" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" :disabled="mostraCompartilhamento || mostraOutrasInfoVersaoConfig" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-primary is-outlined" @click="callCompartilhamento(oiv)" :disabled="mostraCompartilhamento || mostraOutrasInfoVersaoConfig" title="Compartilhar">
                          <span class="icon is-small">
                            <i class="fas fa-share-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-success is-outlined" @click="callOutrasInformacoesConfig(oiv)" :disabled="mostraCompartilhamento || mostraOutrasInfoVersaoConfig" title="Configurar">
                          <span class="icon is-small">
                            <i class="fas fa-th-list"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="column" v-show="mostraCompartilhamento">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Compartilhar {{ outrasInformacoesSelecionada.descricao }}</p>
            <a class="card-header-icon" @click="mostraCompartilhamento = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Versão</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(oiVersao, index) in outrasInformacoesVersoes" :key="oiVersao.id">
                    <td>{{ oiVersao.versao_plano_contas.descricao }}</td>
                    <td class="has-text-centered">
                      <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                        <span class="icon is-small">
                          <i class="fas fa-trash-alt"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraCompartilhamento = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>

      <div class="column" v-show="mostraOutrasInfoVersaoConfig">
        <div class="card">
          <header class="card-header has-background-grey">
            <p class="card-header-title has-text-white">Linhas de Outras Informações {{ outrasInformacoesSelecionada.descricao }}</p>
            <a class="card-header-icon" @click="mostraOutrasInfoVersaoConfig = false">
              <span class="icon">
                <i class="fas fa-times"></i>
              </span>
            </a>
          </header>
          <div class="card-content">
            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Sequencial</th>
                    <th>Descrição</th>
                    <th class="has-text-centered">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(linha, index) in linhasOutrasInformacoes" :key="linha.id">
                    <td>{{ linha.sequencial }}</td>
                    <td>{{ linha.descricao }}</td>
                    <td class="has-text-centered">
                      <div class="buttons is-centered">
                        <button class="button is-small is-info is-outlined" @click="edit(index)" title="Editar">
                          <span class="icon is-small">
                            <i class="fas fa-edit"></i>
                          </span>
                        </button>
                        <button class="button is-small is-danger is-outlined" @click="erase(index)" title="Excluir">
                          <span class="icon is-small">
                            <i class="fas fa-trash-alt"></i>
                          </span>
                        </button>
                        <button class="button is-small is-success is-outlined" @click="abrirFormulas(linha)" title="Fórmula do perfil">
                          <span class="icon is-small">
                            <i class="fas fa-calculator"></i>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <footer class="card-footer">
            <a @click="mostraOutrasInfoVersaoConfig = false" class="card-footer-item">Fechar</a>
          </footer>
        </div>
      </div>
    </div>
    
    <oiv-formula-perfil v-if="linhaSelecionada" :key="linhaSelecionada.id" :visivel="mostrarFormulas" :linha="linhaSelecionada" @fechar="fecharFormulas"/>

  </div>
</template>

<script>
    import {http} from '../../services/config'
    import OivFormulaPerfil from './OutrasInformacoesFormulaPerfil.vue'

    export default {
        name: "OutrasInformacoesVersao",

        components: { OivFormulaPerfil },        

        data(){
            return{
                outraInformacao: {
                    id: null,
                    descricao: null,
                    comentario: null,
                    nome_formula: null,
                    usuario: null
                },
                outrasInformacoesCompartilhar: { id: null,
                    outras_informacoes_versao: null,
                    versao_plano_contas: null
                },
                outrasInformacoesVersaoConfig: {
                    id: null,
                    sequencial: null,
                    descricao: null,
                    formula: null,
                    tipo_evolucao_desejada: "A",
                    eCalculado: "S",
                    outrasInformacoesVersao: null
                },
                versoesPlanoContas: [],
                outrasInformacoes: [],
                linhasOutrasInformacoes: [],
                outrasInformacoesVersoes: [],
                isShowModal: false,
                mostraOutrasInfoVersaoConfig: false, 
                mostraCompartilhamento: false,
                outrasInformacoesSelecionada: {
                    id: null,
                    descricao: null
                },
                previous: null,
                next: null,
                page: null,
                numpages: null,
                mostrarFormulas: false,
                linhaSelecionada: null,
            }
        },

        methods: {
            abrirFormulas(linha) {
              this.linhaSelecionada = linha;
              this.mostrarFormulas = true;
            },       
            
            fecharFormulas() {
              this.mostrarFormulas = false;
              this.linhaSelecionada = null;
            },            
            add: function() {
                this.clearFields()
                this.isShowModal = true              
            },

            edit: function(index){
                if (!this.mostraOutrasInfoVersaoConfig && !this.mostraCompartilhamento) {
                    this.outraInformacao.id = this.outrasInformacoes[index].id
                    this.outraInformacao.descricao = this.outrasInformacoes[index].descricao
                    this.outraInformacao.nome_formula = this.outrasInformacoes[index].nome_formula
                    this.outraInformacao.comentario = this.outrasInformacoes[index].comentario
                    this.outraInformacao.usuario = this.outrasInformacoes[index].usuario
                    this.outraInformacao.index = index
                }
                else {
                    this.outrasInformacoesVersaoConfig.id = this.linhasOutrasInformacoes[index].id
                    this.outrasInformacoesVersaoConfig.descricao = this.linhasOutrasInformacoes[index].descricao
                    this.outrasInformacoesVersaoConfig.sequencial = this.linhasOutrasInformacoes[index].sequencial

                    if (this.linhasOutrasInformacoes[index].e_calculado) {
                        this.outrasInformacoesVersaoConfig.eCalculado = "S"
                    } else {
                        this.outrasInformacoesVersaoConfig.eCalculado = "N"
                    }

                    this.outrasInformacoesVersaoConfig.formula = this.linhasOutrasInformacoes[index].formula
                    this.outrasInformacoesVersaoConfig.outrasInformacoesVersao = this.outrasInformacoesSelecionada
                    this.outrasInformacoesVersaoConfig.tipo_evolucao_desejada = this.linhasOutrasInformacoes[index].tipo_evolucao_desejada
                    this.outrasInformacoesVersaoConfig.index = index
                }
                this.isShowModal = true
            },

            erase: function(index){
                if (window.confirm('Confirma exclusão?')) {
                    if (!this.mostraOutrasInfoVersaoConfig && !this.mostraCompartilhamento) {
                        http.delete('/outrasInformacoesVersao/excluir/'+this.outrasInformacoes[index].id).then(response =>{
                            this.outrasInformacoes.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    } else if (this.mostraCompartilhamento) {
                        http.delete('/outrasInformacoesVersao/excluirVersoes/'+this.outrasInformacoesVersoes[index].id).then(response =>{
                            this.outrasInformacoesVersoes.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    }
                    else {
                        http.delete('/outrasInformacoesVersaoConfig/excluir/'+this.linhasOutrasInformacoes[index].id).then(response =>{
                            this.linhasOutrasInformacoes.splice(index, 1)
                            if (response.status == 204) {
                                alert('Registro excluído!')
                            }
                        }).catch(e => {
                            console.log(e);
                        })
                    }
                }
            },

            callCompartilhamento: function(outraInfo) {
                this.mostraCompartilhamento = true
                this.outrasInformacoesSelecionada = outraInfo
                http.get('outrasInformacoesVersao/listarVersoes/', {params: {
                    idOutrasInformacoesVersao: this.outrasInformacoesSelecionada.id
                }}).then(response => {
                    this.outrasInformacoesVersoes = response.data.results
                })
            },

            clearFields: function() {
                if (!this.mostraOutrasInfoVersaoConfig && !this.mostraCompartilhamento) {
                    this.outraInformacao = { id: null,
                    descricao: null,
                    comentario: null,
                    nome_formula: null,
                    usuario: null,
                    index: null }
                } else if (this.mostraCompartilhamento) {
                    this.outrasInformacoesCompartilhar = {id: null,
                        outras_informacoes_versao: null,
                        versao_plano_contas: null }
                } else {
                    this.outrasInformacoesVersaoConfig = {
                        id: null,
                        outrasInformacoesVersao: this.outrasInformacoesSelecionada,
                        sequencial: null,
                        descricao: null,
                        formula: null,
                        tipo_evolucao_desejada: "A",
                        eCalculado: "S",
                        index: null
                    }
                }
            },

            callOutrasInformacoesConfig: function(outraInfo) {
                this.mostraOutrasInfoVersaoConfig = true
                this.outrasInformacoesSelecionada = outraInfo
                http.get('outrasInformacoesVersaoConfig/listar/', {params: {
                    idOutrasInformacoesVersao: this.outrasInformacoesSelecionada.id
                }}).then(response => {
                    this.linhasOutrasInformacoes = response.data.results
                })
            },

            save: function(){
                var data

                if (!this.mostraOutrasInfoVersaoConfig && !this.mostraCompartilhamento) {
                    if (this.outraInformacao.descricao == null) {
                        alert('Descrição não preenchida!')
                        return
                    }

                    if (this.outraInformacao.nome_formula == null) {
                        alert('Nome da fórmula não preenchida!')
                        return
                    }

                    data = {id: this.outraInformacao.id,
                        usuario: this.$store.state.idUser,
                        descricao: this.outraInformacao.descricao,
                        nome_formula: this.outraInformacao.nome_formula, 
                        comentario: this.outraInformacao.comentario
                    }

                    let formData = new FormData()

                    formData.append('id', data.id)
                    formData.append('usuario', data.usuario)
                    formData.append('descricao', data.descricao)
                    formData.append('nome_formula', data.nome_formula)
                    formData.append('comentario', data.comentario)

                    if (this.outraInformacao.id == null) {
                        http.post('/outrasInformacoesVersao/adicionar', formData).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.outraInformacao.id = response.data.id
                                this.outrasInformacoes.push(this.outraInformacao)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    } 
                    else {
                        http.put('/outrasInformacoesVersao/editar/'+this.outraInformacao.id, formData).then(response =>{
                            this.outrasInformacoes[this.outraInformacao.index].descricao = response.data.descricao
                            this.outrasInformacoes[this.outraInformacao.index].nome_formula = this.outraInformacao.nome_formula
                            this.outrasInformacoes[this.outraInformacao.index].comentario = this.outraInformacao.comentario
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    }
                } else if (this.mostraCompartilhamento) {
                    if (this.outrasInformacoesCompartilhar.versao_plano_contas == null) {
                        alert('Versão não informada!')
                        return
                    }

                    data = {id: this.outrasInformacoesCompartilhar.id,
                        outras_informacoes_versao: this.outrasInformacoesSelecionada.id,
                        versao_plano_contas: this.outrasInformacoesCompartilhar.versao_plano_contas.id
                    }

                    if (this.outrasInformacoesCompartilhar.id == null) {
                        http.post('/outrasInformacoesVersao/adicionarVersoes', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.outrasInformacoesCompartilhar.id = response.data.id
                                this.outrasInformacoesVersoes.push(this.outrasInformacoesCompartilhar)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    } 
                }    
                else {
                    if (this.outrasInformacoesVersaoConfig.descricao == null) {
                        alert('Descrição não informada!')
                        return
                    }

                    if (this.outrasInformacoesVersaoConfig.sequencial == null) {
                        alert('Sequencial não informado!')
                        return
                    }

                    if (this.outrasInformacoesVersaoConfig.formula == null && this.outrasInformacoesVersaoConfig.eCalculado == "S") {
                        alert('Fórmula não informada!')
                        return
                    }

                    data = {id: this.outrasInformacoesVersaoConfig.id,
                        outras_informacoes_versao: this.outrasInformacoesSelecionada.id,
                        sequencial: this.outrasInformacoesVersaoConfig.sequencial,
                        descricao: this.outrasInformacoesVersaoConfig.descricao,
                        formula: this.outrasInformacoesVersaoConfig.formula,
                        tipo_evolucao_desejada: this.outrasInformacoesVersaoConfig.tipo_evolucao_desejada,
                        e_calculado: false
                    }

                    if (this.outrasInformacoesVersaoConfig.eCalculado == 'S') (
                        data.e_calculado = true
                    )

                    if (this.outrasInformacoesVersaoConfig.id == null) {
                        http.post('/outrasInformacoesVersaoConfig/adicionar', data).then(response =>{
                            if (response.data.id != undefined && response.data.id != '') {
                                this.outrasInformacoesVersaoConfig.id = response.data.id
                                this.linhasOutrasInformacoes.push(this.outrasInformacoesVersaoConfig)
                                this.clearFields()
                            } else {
                                alert(response.request.responseText)
                            }
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    } 
                    else {
                        http.put('/outrasInformacoesVersaoConfig/editar/'+this.outrasInformacoesVersaoConfig.id, data).then(response =>{
                            this.linhasOutrasInformacoes[this.outrasInformacoesVersaoConfig.index].outras_informacoes_versao = this.outrasInformacoesSelecionada
                            this.linhasOutrasInformacoes[this.outrasInformacoesVersaoConfig.index].sequencial = response.data.sequencial
                            this.linhasOutrasInformacoes[this.outrasInformacoesVersaoConfig.index].descricao = response.data.descricao
                            this.linhasOutrasInformacoes[this.outrasInformacoesVersaoConfig.index].e_calculado = response.data.e_calculado
                            this.linhasOutrasInformacoes[this.outrasInformacoesVersaoConfig.index].formula = response.data.formula
                            this.linhasOutrasInformacoes[this.outrasInformacoesVersaoConfig.index].tipo_evolucao_desejada = response.data.tipo_evolucao_desejada
                        }).catch(e => {
                            alert(e.response.data);
                            return
                        })
                    }                    
                }

            }
        },

        mounted: function() {
        },
        
        created: function() {
            http.get('versoesPlanoContas/listar').then(response => {
                this.versoesPlanoContas = response.data.results
            })

            http.get('outrasInformacoesVersao/listar/').then(response => {
                this.outrasInformacoes = response.data.results
                this.previous = response.data.previous
                this.next = response.data.next
                this.page = response.data.page
                this.numpages = response.data.numpages
            })
        }
    }
</script>

<style scoped>
</style>